import React from 'react'

// Material-UI
import { makeStyles } from '@material-ui/styles'
import Button from '@material-ui/core/Button'

// App
import Spacer from 'genjo-ui/core/Spacer'

import { LoginCard } from './LoginCard'
import { EmailLoginForm } from './EmailLoginForm'
import { ForgotPasswordForm } from './ForgotPasswordForm'


const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    backgroundImage: `url('/img/bg/login.jpg')`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundAttachment: 'fixed',
    backgroundSize: 'cover',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&::before': {
      height: '100%',
      width: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      content: '""',
      backgroundColor: theme.palette.background.default,
      animation: '$fadein 1s 1 ease-in-out both',
    },
  },

  container: {
    display: 'flex',
    direction: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  card: {
    minWidth: 360,
    maxWidth: 360,
    margin: '64px auto',
    position: 'absolute',
  },

  logo: {
    height: 90,
    width: 'auto',
    textAlign: 'center',
    marginBottom: 16,
  },

  '@keyframes fadein': {
    from: { opacity: 1 },
    to: { opacity: 0 },
  },
}))



/** Sign In Page */
const LoginPage = () => {
  const classes = useStyles()
  const [forgotPassword, setForgotPassword] = React.useState(false)

  return (
    <>
      <div className={classes.root}>
        <LoginCard isIn>
          <EmailLoginForm isIn />

          <Spacer size={16} axis="vertical" />

          <Spacer size={32} axis="vertical" />

          <div style={{ width: '100%', textAlign: 'center' }}>
            <Button
              color="primary"
              onClick={() => setForgotPassword(true)}
            >
              Reset password
            </Button>
          </div>


        </LoginCard>
      </div>

      {forgotPassword && (
        <ForgotPasswordForm onClose={() => setForgotPassword(false)} />
      )}
    </>
  )
}

export default LoginPage
